import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import AppTimeHeader from '../containers/AppTimeHeader'
import { withNamespaces } from "react-i18next"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { postTimeAccess } from '../actions/qrstime'
import { KeyRound } from 'lucide-react'
import ReactCountryFlag from 'react-country-flag'

const PHONE_PREFIXES = [
  { code: 'ES', dial: '+34', name: 'España' },
  { code: 'GB', dial: '+44', name: 'UK' },
  { code: 'FR', dial: '+33', name: 'France' },
  { code: 'DE', dial: '+49', name: 'Deutschland' },
  { code: 'IT', dial: '+39', name: 'Italia' },
  { code: 'PT', dial: '+351', name: 'Portugal' },
  { code: 'NL', dial: '+31', name: 'Nederland' },
  { code: 'BE', dial: '+32', name: 'België' },
  { code: 'CH', dial: '+41', name: 'Schweiz' },
  { code: 'AT', dial: '+43', name: 'Österreich' },
  { code: 'SE', dial: '+46', name: 'Sverige' },
  { code: 'NO', dial: '+47', name: 'Norge' },
  { code: 'DK', dial: '+45', name: 'Danmark' },
  { code: 'US', dial: '+1',  name: 'USA' },
  { code: 'BR', dial: '+55', name: 'Brasil' },
  { code: 'MX', dial: '+52', name: 'México' },
  { code: 'AR', dial: '+54', name: 'Argentina' },
  { code: 'CL', dial: '+56', name: 'Chile' },
  { code: 'CO', dial: '+57', name: 'Colombia' },
  { code: 'JP', dial: '+81', name: 'Japan' },
  { code: 'CN', dial: '+86', name: 'China' },
  { code: 'IN', dial: '+91', name: 'India' },
  { code: 'AU', dial: '+61', name: 'Australia' },
  { code: 'RU', dial: '+7',  name: 'Россия' },
];

class TimeAccessView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      phonePrefix: '+34',
      phoneNumber: '',
      accessCode: '',
      notFound: false,
      isSearching: false,
      prefixOpen: false,
    }
    this.prefixRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  handleOutsideClick = (e) => {
    if (this.prefixRef.current && !this.prefixRef.current.contains(e.target)) {
      this.setState({ prefixOpen: false });
    }
  }

  getButtonStyle() {
    const { qrData } = this.props;
    const buttonColor1 = qrData?.headerConfig?.buttonColor1 || '#01315f';
    const buttonColor2 = qrData?.headerConfig?.buttonColor2 || '#067ddb';
    const buttonText = qrData?.headerConfig?.buttonText || '#ffffff';

    return {
      background: `linear-gradient(135deg, ${buttonColor1}, ${buttonColor2})`,
      color: buttonText,
      border: 'none'
    };
  }

  getPrimaryColor() {
    const { qrData } = this.props;
    return qrData?.headerConfig?.primaryColor || '#01315f';
  }

  handlePhoneChange = (e) => {
    this.setState({ phoneNumber: e.target.value.replace(/\D/g, '') });
  }

  selectPrefix = (dial) => {
    this.setState({ phonePrefix: dial, prefixOpen: false });
  }

  togglePrefixDropdown = () => {
    this.setState(s => ({ prefixOpen: !s.prefixOpen }));
  }

  handleAccessCodeChange = (e) => {
    this.setState({ accessCode: e.target.value });
  }

  handleRedirect = () => {
    const { id } = this.props.match.params;
    history.push(`/qrsale/${id}`);
  }

  isContinueDisabled() {
    return this.state.phoneNumber.length < 7 || this.state.accessCode.length < 4 || this.state.isSearching;
  }

  handleSearch = () => {
    if (this.isContinueDisabled()) return;

    const { id } = this.props.match.params;

    this.setState({ isSearching: true, notFound: false });

    this.props.postTimeAccess({
      phoneNumber: this.state.phonePrefix.replace('+', '') + this.state.phoneNumber,
      accessCode: this.state.accessCode,
      qrToken: id,
    })
    .then((answer) => {
      this.setState({ isSearching: false });

      if (answer.error || !answer.response) {
        this.setState({ notFound: true });
        return;
      }

      // Navigate to TimeOpenView with locker data
      history.push(`/timeOpenView/${id}`, {
        lockerData: answer.response.locker,
        rentalData: answer.response.rental,
        machineData: answer.response.machine,
        matrixData: answer.response.matrix,
        timeConfig: answer.response.timeConfig,
        pricing: answer.response.pricing,
        phoneNumber: this.state.phonePrefix.replace('+', '') + this.state.phoneNumber,
        accessCode: this.state.accessCode,
        qrToken: id,
      });
    })
    .catch((error) => {
      console.error(error);
      this.setState({ isSearching: false, notFound: true });
    });
  }

  render() {
    const { t } = this.props;
    const { phonePrefix, phoneNumber, accessCode, notFound, isSearching, prefixOpen } = this.state;
    const selectedCountry = PHONE_PREFIXES.find(p => p.dial === phonePrefix) || PHONE_PREFIXES[0];
    const buttonStyle = this.getButtonStyle();
    const primaryColor = this.getPrimaryColor();

    return (
      <div className="timeBackground">
        <AppTimeHeader />
        <div className="time-page-wrap">
          <div className="time-content time-locker-selector-wide">
            <div className="time-page-header">
              <div className="time-page-header-icon" style={buttonStyle}>
                <KeyRound size={24} strokeWidth={2} />
              </div>
              <div className="time-page-header-text">
                <h2>{t('Accede a tu taquilla')}</h2>
                <p>{t('Introduce tu teléfono y código para abrir tu taquilla alquilada')}</p>
              </div>
            </div>

            <div className="time-phone-card">
              <div className="time-phone-input-wrapper">
                <label className="time-label">{t('TELÉFONO')}</label>
                <div className="time-phone-row">
                  <div className="time-prefix-picker" ref={this.prefixRef}>
                    <button
                      type="button"
                      className="time-prefix-trigger"
                      onClick={this.togglePrefixDropdown}
                    >
                      <ReactCountryFlag
                        countryCode={selectedCountry.code}
                        svg
                        style={{ width: '1.4em', height: '1.4em', borderRadius: '3px' }}
                      />
                      <span>{selectedCountry.dial}</span>
                      <i className="fas fa-chevron-down" style={{ fontSize: '0.6rem', opacity: 0.6 }}></i>
                    </button>
                    {prefixOpen && (
                      <div className="time-prefix-dropdown">
                        {PHONE_PREFIXES.map(p => (
                          <div
                            key={p.code}
                            className={`time-prefix-option${p.dial === phonePrefix ? ' selected' : ''}`}
                            onClick={() => this.selectPrefix(p.dial)}
                          >
                            <ReactCountryFlag
                              countryCode={p.code}
                              svg
                              style={{ width: '1.3em', height: '1.3em', borderRadius: '3px' }}
                            />
                            <span className="time-prefix-dial">{p.dial}</span>
                            <span className="time-prefix-name">{p.name}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <input
                    type="tel"
                    className="time-phone-number"
                    value={phoneNumber}
                    onChange={this.handlePhoneChange}
                    placeholder="600 000 000"
                    maxLength={12}
                  />
                </div>
              </div>

              <div className="time-phone-input-wrapper" style={{ marginTop: '14px' }}>
                <label className="time-label">{t('CÓDIGO DE ACCESO')}</label>
                <p className="time-label-hint" style={{ margin: '2px 0 8px', fontSize: '0.82rem', color: '#888' }}>{t('(El código de 4 dígitos de tu ticket)')}</p>
                <input
                  className="time-input-full"
                  type="tel"
                  pattern="[0-9]*"
                  maxLength="4"
                  value={accessCode}
                  onChange={this.handleAccessCodeChange}
                  placeholder="• • • •"
                  style={{ borderColor: primaryColor, fontSize: '1.6rem', textAlign: 'center', letterSpacing: '10px', fontWeight: 700 }}
                />
              </div>

              <button
                className="time-continue-btn"
                style={{ ...buttonStyle, marginTop: '20px' }}
                onClick={this.handleSearch}
                disabled={this.isContinueDisabled()}
              >
                {isSearching ? (
                  <div className="spinner-border spinner-border-sm text-light" role="status"></div>
                ) : (
                  t('ACCEDER')
                )}
              </button>

              <button
                className="time-continue-btn"
                style={{ marginTop: '10px', background: 'none', border: `2px solid ${primaryColor}`, color: primaryColor }}
                onClick={this.handleRedirect}
              >
                {t('Volver')}
              </button>
            </div>

            <div className="time-disclaimer">
              <span>{t('*Los datos personales recabados no se usarán en ningún caso para ofrecer comunicados comerciales de ningún tipo.')}</span>
            </div>
          </div>
        </div>

        {/* Not Found Modal */}
        <Modal isOpen={notFound}>
          <ModalBody className="text-center time-modal">
            <div className="time-modal-icon time-error">✕</div>
            <h3>{t('Reserva no encontrada')}</h3>
            <p>{t('No se ha encontrado ninguna taquilla alquilada con estos datos. Comprueba tu teléfono y código de acceso.')}</p>
            <div className="time-not-found-img">
              <img src="/images/locker_BNS.png" alt="Not Found" className="time-modal-img" />
            </div>
          </ModalBody>
          <ModalFooter className="time-modal-footer">
            <Button className="time-modal-btn-retry" onClick={() => this.setState({ notFound: false })}>
              {t('Reintentar')}
            </Button>
            <Button className="time-modal-btn-back" onClick={this.handleRedirect}>
              {t('Volver al inicio')}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: true,
  qrData: state.qrs.qr
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  postTimeAccess: bindActionCreators(postTimeAccess, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(TimeAccessView));
